import React from "react";
import Image from "next/image";
import Link from "next/link";

function Page() {
  return (
    <>
      {/* footer section  */}

      <footer className="footer-section">
        <div className="container">
          <div className="row footer-main-bx">
            <div className="col-md-6">
              <div className="footer-info">
                <p className="footer-text">
                  Private chefs, food trucks, decorators, bartenders, and <br />
                  more — ready when you are. Plan like Link pro with the <br />{" "}
                  app built for celebrations.
                </p>
                <div className="d-flex footer-app-btn">
                  {/* <button
                    className="btn google-play-btn d-flex text-start align-items-center  me-0 me-md-3"
                    type="button"
                  > */}
                  <Link
                    target="_blank"
                    href={process.env.NEXT_PUBLIC_PLAYSTORE}
                    className="btn google-play-btn d-flex text-start align-items-center"
                    type="button"
                    
                  >
                    <Image
                      src="/images/google-play-logo.svg"
                      alt="Google play"
                      width={21}
                      height={23}
                    />
                    <div className="app-btn-spacing">
                      <span className="text-transform-uppercase">
                        GET IT ON
                      </span>
                      <h5>Google Play</h5>
                    </div>
                  </Link>
                  {/* </button> */}
                  <Link
                    target="_blank"
                    href={process.env.NEXT_PUBLIC_APPSTORE}
                    className="btn google-play-btn d-flex text-start align-items-center"
                    type="button"
                    
                  >
                    <Image
                      src="/images/apple-logo.svg"
                      alt="apple logo"
                      width={18}
                      height={21}
                    />
                    <div className="app-btn-spacing">
                      <span>Download on the</span>
                      <h5>App Store</h5>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-md-6">
                  <ul className="footer-items list-unstyled">
                    <h5 className="footer-head">Info</h5>
                    <li className="footer-text">
                      <Link href="/privacy-policy"  target="_blank">
                        Privacy Policy
                      </Link>
                    </li>
                    <li className="footer-text">
                      <Link href="/terms-condition"  target="_blank">
                        Terms and conditions
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <ul className="footer-items list-unstyled">
                    <h5 className="footer-head">Contacts</h5>
                    <li className="footer-text">
                      <Link href="tel:+1-513-208-0774">+1-513-208-0774</Link>
                    </li>
                    <li className="footer-text">
                      <Link href="mailto:Contact@itsonlyonestop.com">
                        Contact@itsonlyonestop.com
                      </Link>
                    </li>
                    <div className="footer-text">
                      <Link href="#">
                        824 Broadway St, Cincinnati OH, 45202
                      </Link>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="row footer-main-bx footer-right-section-spacing">
            <div className="col-md-6">
              <p className="all-right-text">
                © 2025 One Stop - All Rights Reserved.
              </p>
            </div>
            <div className="col-md-6">
              <div className="footer-images">
                <Link
                  href="https://www.instagram.com/itsonlyonestop"
                  target="_blank"
                >
                  <Image
                    src="/images/insta.svg"
                    alt="instagram logo"
                    width={18}
                    height={18}
                  />
                </Link>

                <Link
                  href="https://www.threads.com/@itsonlyonestop"
                  target="_blank"
                >
                  <Image
                    src="/images/threads.svg"
                    alt="instagram logo"
                    width={18}
                    height={18}
                  />
                </Link>

                <Link
                  href="https://www.facebook.com/share/16XbEVGTZU/?mibextid=wwXIfr"
                  target="_blank"
                >
                  <Image
                    src="/images/facebook.svg"
                    alt="facebook logo"
                    width={18}
                    height={18}
                  />
                </Link>
                {/* <Image
                  src="/images/youtube.svg"
                  alt="youtube logo"
                  width={18}
                  height={18}
                /> */}
                <Link
                  href="https://www.linkedin.com/company/its-only-onestop/"
                  target="_blank"
                >
                  <Image
                    src="/images/linkedin.svg"
                    alt="linkedin logo"
                    width={18}
                    height={18}
                  />
                </Link>
                {/* <Image
                  src="/images/tiktok.svg"
                  alt="tiktok logo"
                  width={18}
                  height={18}
                /> */}
                {/* <Image
                  src="/images/x.svg"
                  alt="x logo"
                  width={18}
                  height={18}
                /> */}
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Page;
